

/* eslint-disable no-unused-vars */
enum MODES {
  map  = "map",
  list = "list",
  card = "card",
  unknown = "unknown",
}
/* eslint-enable no-unused-vars */

export {
  MODES as MapModes,
}
